<template>
  <div class="about">
    <h2>查单词</h2>
    <div class="inputBox">
      <input
        v-model="word"
        placeholder="edit me"
        autofocus="autofocus"
        @blur="searchWord"
        @focus="clearWord"
      />
    </div>
    <div class="tranBox">
      <div class="tran" v-if="sw.length != ''">
        <div>翻译：{{ sw.translation }}</div>
        <div v-if="sw.web">
          网络翻译：
          <div v-for="web in sw.web" v-bind:key="web.index">
            {{ web.key }}:
            <span v-for="value in web.value" v-bind:key="value.index">{{ value }};</span>
          </div>
        </div>
        <audio v-if="sw.basic" :src="sw.basic['uk-speech']" controls="controls" autoplay></audio>
        <audio v-else-if="sw.speakUrl" :src="sw.speakUrl" controls="controls" autoplay></audio>
      </div>
    </div>
    <h2>看作文</h2>
    <div class="compositionBox" v-if="list.length!=0">
      <div class="title">{{ list[i].title }}</div>
      <template v-for="original in list[i].original">
        <div class="original" :key="original.index">{{ original }}</div>
      </template>
      <template v-for="translation in list[i].translation">
        <div class="translation" :key="translation.index">{{ translation }}</div>
      </template>
    </div>
  </div>
</template>
<script>
const sha256 = require("js-sha256").sha256; //引入sha256库
export default {
  name: "about",
  data: function() {
    return {
      word: "",
      sw: "",
      i: 0,
      list: []
    };
  },
  created() {
    this.$axios
      .get(
        "./composition.json"
      )
      .then(
        response => {
          let list = response.data.composition;
          this.list = list;
          window.console.log(list);
        },
        response => {
          alert(response.status);
        }
      );
  },
  methods: {
    clearWord() {
      this.sw = "";
      this.word = "";
    },
    searchWord() {
      this.word = this.word.trim();
      if (this.word == "" || this.word == null || this.word == undefined) {
        this.values = "查找单词不能为空";
        return;
      }
      let appKey = "734e7ff45d43a8ad",
        key = "CASfskxokZFA72QMmLYZZPPPU9oMWuKG", //注意：暴露appSecret，有被盗用造成损失的风险
        salt = new Date().getTime(),
        curTime = Math.round(new Date().getTime() / 1000),
        query = this.word,
        // 多个query可以用\n连接  如 query='apple\norange\nbanana\npear'
        from = "auto",
        to = "auto",
        str1 = appKey + truncate(query) + salt + curTime + key,
        sign = sha256(str1);
      this.$http
        .jsonp(
          "https://openapi.youdao.com/api?q=" +
            query +
            "&&appKey=" +
            appKey +
            "&&salt=" +
            salt +
            "&&from=" +
            from +
            "&&to=" +
            to +
            "&&sign=" +
            sign +
            "&&signType=v3" +
            "&&curtime=" +
            curTime +
            "&&ext=mp3&&voice=0"
        )
        .then(res => {
          // this.$router.push("/about");
          this.sw = res.data;
          window.console.log(res.data);
        })
        .catch(res => {
          window.console.log(res.status);
        });
      function truncate(q) {
        var len = q.length;
        if (len <= 20) return q;
        return q.substring(0, 10) + len + q.substring(len - 10, len);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.about {
  width: 100%;
  display: flex;
  flex-direction: column;
  h2 {
    padding: 0 20px;
    text-align: center;
  }
  .inputBox {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    input {
      width: 80%;
      padding: 10px 20px;
      margin: 10px 10px;
    }
  }
  .tranBox {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .tran {
      width: 80%;
      padding: 20px 25px;
      background: #fff;
      box-shadow: 0 0 5px #ccc;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      audio {
        margin: 0 auto;
      }
    }
  }
  .compositionBox {
    padding: 20px;
    .title {
      text-align: center;
      font-weight: bolder;
    }
    .original {
      line-height: 30px;
      margin-bottom: 10px;
    }
    .translation {
      line-height: 30px;
      margin-bottom: 10px;
    }
  }
}
</style>
